if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyATC extends HTMLElement {
      connectedCallback() {
        this.state = this.dataset.state;
        this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';

        this.mainForm = document.querySelector('product-form form');
        this.mainProductForm = document.querySelector('product-form');
        this.mainSubmit = this.mainProductForm ? this.mainProductForm.querySelector('[type="submit"]') : null;
        this.mainVariantRoot = document.querySelector('variant-selects, variant-radios');
        this.mainSection = this.mainProductForm ? this.mainProductForm.closest('[id^="MainProduct-"]') : null;

        const json = this.querySelector('[data-sticky-variants]');
        try {
          this.variants = json ? JSON.parse(json.textContent) : [];
        } catch (_) {
          this.variants = [];
        }

        this.stickySelect = this.querySelector('[data-sticky-variant-select]');
        this.stickyPrice = this.querySelector('[data-sticky-price]');
        this.stickyMobilePrice = this.querySelector('[data-sticky-mobile-price]');
        this.stickyButton = this.querySelector('[data-sticky-button]');
        this.stickyLabel = this.querySelector('[data-sticky-button-label]');

        this.bindEvents();
        this.setupObserver();
      }

      setupObserver() {
        const anchor =
          (this.mainProductForm && this.mainProductForm.querySelector('.product-form__buttons')) ||
          this.mainProductForm ||
          this.mainForm;

        if (!anchor) {
          this.reveal();
          return;
        }

        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.conceal();
              } else if (entry.boundingClientRect.top < 0) {
                this.reveal();
              } else {
                this.conceal();
              }
            });
          },
          { threshold: 0 }
        );
        io.observe(anchor);
      }

      reveal() {
        this.hidden = false;
        void this.offsetHeight;
        this.classList.add('is-visible');
      }

      conceal() {
        this.classList.remove('is-visible');
      }

      bindEvents() {
        if (this.stickyButton) {
          this.stickyButton.addEventListener('click', (e) => this.onButtonClick(e));
        }

        if (this.stickySelect) {
          this.stickySelect.addEventListener('change', (e) => this.onStickySelectChange(e));
        }

        if (this.mainVariantRoot) {
          this.mainVariantRoot.addEventListener('change', () => {
            // Dawn updates the hidden id input synchronously inside its own
            // change handler; a microtask is enough to read the updated state.
            window.setTimeout(() => this.syncFromMain(), 0);
          });
        }
      }

      onButtonClick(e) {
        e.preventDefault();
        if (this.state === 'submit') {
          this.submitMainForm();
        } else {
          this.scrollToBuyBox();
        }
      }

      submitMainForm() {
        if (!this.mainSubmit) return;
        this.classList.add('is-loading');
        this.mainSubmit.click();
        window.setTimeout(() => this.classList.remove('is-loading'), 1500);
      }

      scrollToBuyBox() {
        const target =
          document.querySelector(".product__info-wrapper.grid__item") ||
          (this.mainProductForm && this.mainProductForm.querySelector('.product-form__buttons')) ||
          this.mainSection ||
          this.mainForm;
        if (!target) return;

        const header = document.querySelector('sticky-header, .section-header');
        const headerOffset = header ? header.offsetHeight : 0;
        const rect = target.getBoundingClientRect();
        const top = window.pageYOffset + rect.top - headerOffset - 24;

        window.scrollTo({ top, behavior: 'smooth' });
      }

      onStickySelectChange(e) {
        const value = e.target.value;
        if (!this.mainVariantRoot) return;

        const mainSelect = this.mainVariantRoot.querySelector('select');
        if (mainSelect) {
          mainSelect.value = value;
          mainSelect.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }

        const radio = this.mainVariantRoot.querySelector(
          `input[type="radio"][value="${CSS.escape(value)}"]`
        );
        if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      syncFromMain() {
        const variant = this.getCurrentVariant();
        if (!variant) return;

        if (this.stickySelect) {
          const nextValue = variant.option1;
          if (nextValue && this.stickySelect.value !== nextValue) {
            this.stickySelect.value = nextValue;
          }
        }

        const formatted = this.formatMoney(variant.price);
        if (this.stickyPrice) this.stickyPrice.textContent = formatted;
        if (this.stickyMobilePrice) this.stickyMobilePrice.textContent = formatted;

        // State 2 is a scroll trigger, not an add-to-cart; never disable it.
        if (this.stickyButton && this.state === 'submit') {
          this.stickyButton.disabled = !variant.available;
          if (this.stickyLabel) {
            this.stickyLabel.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
          }
        }
      }

      getCurrentVariant() {
        if (!this.mainForm) return null;
        const idInput = this.mainForm.querySelector('[name="id"]');
        if (!idInput) return null;
        const id = parseInt(idInput.value, 10);
        if (!id) return null;
        return this.variants.find((v) => v.id === id) || null;
      }

      formatMoney(cents) {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          return window.Shopify.formatMoney(cents, this.moneyFormat);
        }
        const amount = (cents / 100).toFixed(2);
        return this.moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/g, amount);
      }
    }
  );
}
